import Search from '../../class/Search';

window.pageCurrent = class extends Search {
    presetSearchParameters() {
        let city = appData.page.vars.pageCity;

        // We automatically add the search parameters to the url
        // Must be done before algolia loading so it can be used for filtering
        if (city != null && city != '') {
            window.history.replaceState(null, document.title, '?city=' + city);
        }
    }
};
